import React, { Component } from "react";
import ReactDrawer from "react-drawer";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { parse } from "qs";
import { withRouter } from "react-router-dom";

import * as authDrawerActions from "../../../actions/authDrawer";
import SignIn from "./SignIn";
import RegisterOne from "./RegisterOne";
import RegisterTwo from "./RegisterTwo";
import RegisterThree from "./RegisterThree";
import ForgotPasswordOne from "./ForgotPasswordOne";
import ForgotPasswordTwo from "./ForgotPasswordTwo";
import ForgotPasswordThree from "./ForgotPasswordThree";
import ForgotPasswordFour from "./ForgotPasswordFour";
import { BREAKPOINT_DOWN_MEDIUM } from "../../../config/constants";
import * as authDrawerConstants from "../../../constants/authDrawer";
import { freezeScroll, thawScroll } from "../../../utils/toggleScroll";

import styles from "./AuthDrawer.css";

class AuthDrawer extends Component {
  constructor() {
    super();
    this.onDrawerClose = this.onDrawerClose.bind(this);
    this.state = {
      position: "right",
      mobileDrawer: false,
      isOpen: false,
    };
  }

  componentDidMount() {
    // Ensure that the drawer opens on the left if screen size is mobile
    if (window.matchMedia(BREAKPOINT_DOWN_MEDIUM).matches) {
      this.setState({
        position: "left",
        mobileDrawer: true,
      });
    }

    if (this.props.authDrawer.authDrawerOpen) {
      this.setState({
        isOpen: this.props.authDrawer.authDrawerOpen,
      });
    }

    const parsedQs = parse(this.props.location.search.slice(1));

    // If reset_password_token is present in the query string, open the drawer and point to the new password option
    if (parsedQs && parsedQs.reset_password_token) {
      this.props.authDrawerActions.changeStep(
        authDrawerConstants.FORGOTPASSWORD3
      );
      this.props.authDrawerActions.toggleAuthDrawer(true);
      this.props.authDrawerActions.setPasswordResetInfo(
        parsedQs.reset_password_token,
        parsedQs.email
      );
    }

    // If email_confirmation_token is present, confirm the email
    if (parsedQs && parsedQs.email_confirmation_token && parsedQs.email) {
      this.props.authDrawerActions.confirmEmail(
        parsedQs.email_confirmation_token,
        parsedQs.email
      );
    }

    window.addEventListener("message", event => {
      if (
        event.data &&
        event.data.authToken &&
        event.source.name === authDrawerConstants.FRAME_NAME
      ) {
        this.props.authDrawerActions
          .setAuthToken(event.data.authToken)
          .then(() => {
            // Close the auth drawer when authentication is complete
            this.props.authDrawerActions.toggleAuthDrawer(false);
          });
      }
    });
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.authDrawer.authDrawerOpen !==
      this.props.authDrawer.authDrawerOpen
    ) {
      this.setState({
        isOpen: this.props.authDrawer.authDrawerOpen,
      });
    }
  }

  onDrawerClose() {
    this.props.authDrawerActions.toggleAuthDrawer(false);
  }

  render() {
    if (this.props.authDrawer.authDrawerOpen) {
      freezeScroll();
    } else {
      thawScroll();
    }

    return (
      <div className={styles.root}>
        <ReactDrawer
          open={this.state.isOpen}
          onClose={this.onDrawerClose}
          position={this.state.position}
          className={this.state.mobileDrawer ? styles.mobileDrawer : null}
        >
          {this.props.authDrawer.step === authDrawerConstants.SIGNIN ? (
            <SignIn />
          ) : null}

          {this.props.authDrawer.step === authDrawerConstants.REGISTER1 ? (
            <RegisterOne />
          ) : null}

          {this.props.authDrawer.step === authDrawerConstants.REGISTER2 ? (
            <RegisterTwo />
          ) : null}

          {this.props.authDrawer.step === authDrawerConstants.REGISTER3 ? (
            <RegisterThree />
          ) : null}

          {this.props.authDrawer.step ===
          authDrawerConstants.FORGOTPASSWORD1 ? (
            <ForgotPasswordOne />
          ) : null}

          {this.props.authDrawer.step ===
          authDrawerConstants.FORGOTPASSWORD2 ? (
            <ForgotPasswordTwo />
          ) : null}

          {this.props.authDrawer.step ===
          authDrawerConstants.FORGOTPASSWORD3 ? (
            <ForgotPasswordThree />
          ) : null}

          {this.props.authDrawer.step ===
          authDrawerConstants.FORGOTPASSWORD4 ? (
            <ForgotPasswordFour />
          ) : null}
        </ReactDrawer>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    authDrawer: state.authDrawer,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    authDrawerActions: bindActionCreators(authDrawerActions, dispatch),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(AuthDrawer)
);
